import React from "react";
import { View, Text, TextInput, Button, Icon } from "ui";
import { EditTitle, PicturesList, MemoAlert } from "components";
import { DataProps, Alert, AlertTemplate } from "types";
import { RouteComponentProps, Link } from "react-router-dom";
import { Redirect } from "react-router";
import _ from "lodash";
import { memoMutations } from "api";
import { notify } from "shared/services";
import { styled } from "styles";
import ConfirmDialog from "../components/ConfirmDialog";
import { isAlertExpired } from "./alertList/util";

interface Params {
  memo_id: string;
}

export default class EditMemo extends React.Component<
  DataProps & RouteComponentProps<Params>
> {
  public state = {
    edit: false,
    openDialog: false
  };

  public handleEdit = () => {
    this.setState({ edit: true });
  }

  public handleCreateClick = event => {
    if (!this.props.currentUser.subscribed) {
      notify("Ai nevoie de un abonament activ pentru a creea alerte");
      this.props.history.push("/app/abonament");
      event.preventDefault();
      return;
    }
  }

  public deleteItem = memo => {
    const { openDialog } = this.state;
    return (
      <memoMutations.DeleteMemo>
        {deleteMemo => (
          <ConfirmDialog
            text="Esti sigur ca vrei sa stergi acest memo?"
            open={openDialog}
            onClose={() => this.setState({ openDialog: false })}
            onConfirm={async () => {
              try {
                if (!this.props.currentUser.subscribed) {
                  notify(
                    "Ai nevoie de un abonament activ pentru a sterge memo-uri"
                  );
                  this.setState({ openDialog: false });
                  return;
                }
                let id = memo.id;
                await deleteMemo({ variables: { id } });
                this.setState({ openDialog: false });
                notify("Memo-ul a fost sters");
              } catch (err) {}
            }}
          />
        )}
      </memoMutations.DeleteMemo>
    );
  }

  public render = () => {
    const {
      categories,
      findMemoAlerts,
      findMemoPhotos,
      findMemoById,
      match,
      currentUser
    } = this.props;

    const { openDialog } = this.state;
    const memo = findMemoById(match.params.memo_id);
    if (!memo) {
      return <Redirect to="/app" />;
    }
    const alertsUnsorted = findMemoAlerts(memo.id);
    const alerts = _.sortBy(alertsUnsorted, (alert: Alert) => {
      const isExpired = isAlertExpired(alert);
      const hasTemplate = !!alert.alert_template_id;
      if (isExpired){
        if (!hasTemplate){
          return 1;
        } else {
          return 2;
        }
      } else {
        if (!hasTemplate){
          return 3;
        } else {
          return 4;
        }
      }
    });
    // const alerts = alertsUnsorted;
    const photos = findMemoPhotos(memo.id);
    const category = categories.find(c => c.id === memo.category_id);

    const alertItems: {
      alert?: Alert;
      template?: AlertTemplate;
    }[] = alerts
      .map<{ alert?: Alert; template?: AlertTemplate }>(a => ({ alert: a }))
      .concat(
        category.templates
          .filter(t => !_.find(alerts, { alert_template_id: t.id }))
          .map(t => ({ template: t }))
      );

    return (
      <View
        flexDirection="column"
        p={2}
        alignItems="center"
        justifyContent="center"
      >
        <EditTitle memo={memo} />
        <View mt={4} flexDirection="column" alignSelf="stretch">
          <PicturesList
            photos={photos}
            memo={memo}
            onClick={photo => console.log("photo", photo)}
          />
        </View>

        <CreateAlertButton
          mx={2}
          my={2}
          alignSelf="stretch"
          alignItems="center"
          as={Link}
          to={`/app/memos/${memo.id}/alert?memo=${memo.id}`}
          onClick={this.handleCreateClick}
        >
          <Icon name="plus-circle-outline" size={2} color="white" />
          <Text ml={1} fontSize={4} color="white">
            Creeaza o Alerta
          </Text>
        </CreateAlertButton>
        <View flexDirection="column" mt={2} alignSelf="stretch">
          {alertItems.map(({ alert, template }) => {
            return (
              <MemoAlert
                memo={memo}
                user={currentUser}
                key={`${alert ? alert.id : "null"}-${
                  template ? template.id : "null"
                }`}
                alert={alert}
                template={template}
              />
            );
          })}
        </View>

        <Button
          bg="warning"
          m={2}
          alignSelf="stretch"
          onClick={() => this.setState({ openDialog: true })}
        >
          <Text fontSize={4} color="white">
            Sterge Memo
          </Text>
        </Button>
        {openDialog && this.deleteItem(memo)}
      </View>
    );
  }
}

const CreateAlertButton = styled(Button)`
  text-decoration: none;
` as any;



// WEBPACK FOOTER //
// ./src/pages/EditMemo.tsx